import * as service from './service'
export default {
  namespace: 'equipmentMallMallHome',
  state: {
    categoryList: {},
    zoneSalesList: {},
    pathData: '',
    regionList: [],
    activityList: []
  },
  effects: {
    * getCategoryList ({ payload }, { call, put }) {
      const res = yield call(service.getCategoryList, payload)
      yield put({
        type: 'save',
        payload: {
          categoryList: res.data.data
        }
      })
      return res.data
    },
    * queryList ({ payload }, { call, put }) {
      const res = yield call(service.queryZoneSalesList, payload)
      yield put({
        type: 'save',
        payload: {
          zoneSalesList: res.data.data
        }
      })
      return res.data
    },
    * querySaleList ({ payload }, { call, put }) {
      const res = yield call(service.querySaleList, payload)
      yield put({
        type: 'save',
        payload: {
          saleList: res.data.data
        }
      })
      return res.data
    },
    * getPath ({ payload }, { call, put }) {
      const res = yield call(service.getPath, payload)
      yield put({
        type: 'save',
        payload: {
          pathData: res.data.data
        }
      })
      return res.data
    },
    * regionList ({ payload }, { call, put }) {
      const res = yield call(service.regionList, payload)
      if (res.data.status === 200) {
        yield put({
          type: 'save',
          payload: {
            regionList: res.data.data
          }
        })
      } else {
        Promise.reject()
      }
    },
    * activityList ({ payload }, { call, put }) {
      const res = yield call(service.activityList, payload)
      if (res.data.status === 200) {
        yield put({
          type: 'save',
          payload: {
            activityList: res.data.data
          }
        })
      } else {
        Promise.reject()
      }
    },
    * getActivityData ({ payload }, { call, put }) {
      const res = yield call(service.getActivityData, payload)
      yield put({
        type: 'save',
        payload: {
          getActivityData: res.data.data
        }
      })
      return res.data
    }
  },

  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
